import { Link } from 'react-router-dom';

const installServices = [
  {
    icon: 'ri-camera-fill',
    title: 'HD & 4K Camera Installation',
    description: 'Wired and wireless HD/4K security cameras installed at optimal angles for maximum coverage. Indoor, outdoor, IR night vision, weatherproof, and PTZ options available.',
    stat: 'HD / 4K / PTZ',
    features: ['Indoor & Outdoor', 'Night Vision IR', 'Weatherproof IP66', 'Remote Smartphone View'],
  },
  {
    icon: 'ri-vidicon-fill',
    title: 'CCTV Surveillance Systems',
    description: 'Complete CCTV system design and installation with NVR/DVR recorders, large-format monitors, and remote access for 24/7 property surveillance.',
    stat: 'Full System Install',
    features: ['NVR/DVR Recorders', 'Cloud Backup', 'Motion Detection', 'Multi-Camera Systems'],
  },
  {
    icon: 'ri-alarm-warning-fill',
    title: 'Alarm & Intrusion Detection',
    description: 'Comprehensive alarm systems with door/window sensors, motion detectors, glass break sensors, and optional 24/7 professional monitoring and rapid response.',
    stat: '24/7 Monitoring',
    features: ['Door & Window Sensors', 'Motion Detectors', 'Panic Buttons', 'Pro Monitoring Option'],
  },
  {
    icon: 'ri-door-lock-fill',
    title: 'Access Control Systems',
    description: 'Keypad, key fob, card reader, and biometric fingerprint entry systems. Perfect for offices, warehouses, apartment buildings, and multi-tenant commercial properties.',
    stat: 'Commercial Grade',
    features: ['Keypad / Fob / Card', 'Biometric Options', 'Audit Trail Logs', 'Multi-Door Control'],
  },
  {
    icon: 'ri-home-smart-fill',
    title: 'Smart Home Automation',
    description: 'Full smart home security integration including video doorbells, smart locks, automated lighting, and complete home automation controlled from any smartphone.',
    stat: 'App-Controlled',
    features: ['Video Doorbells', 'Smart Locks', 'Automated Lighting', 'Full App Control'],
  },
  {
    icon: 'ri-map-pin-2-fill',
    title: 'License Plate Recognition (LPR)',
    description: 'LPR camera systems for parking lots, gated communities, commercial properties, and fleet management — automated gate entry and comprehensive vehicle logging.',
    stat: 'LPR Systems',
    features: ['Automated Entry', 'Vehicle Logging', 'Gate Integration', 'Parking Management'],
  },
];

export default function ServiceDetails() {
  return (
    <section className="bg-slate-50 py-24 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-slate-200" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-slate-200" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full text-orange-700 text-xs font-bold uppercase tracking-[0.2em] border border-orange-200 bg-orange-50 mb-4">
            What We Install
          </span>
          <h2 className="font-display text-4xl lg:text-5xl font-black text-slate-900 mb-4">
            Complete Security System Coverage
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            From a single camera to a full enterprise surveillance network — every system professionally
            designed, installed, and supported by our licensed technicians.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {installServices.map((service) => (
            <div
              key={service.title}
              className="group rounded-2xl border border-slate-200 bg-white hover:border-orange-300 hover:shadow-sm transition-all duration-300 p-7 cursor-default"
            >
              <div className="flex items-start justify-between mb-5">
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-orange-100 border border-orange-200 group-hover:bg-orange-200 transition-colors">
                  <i className={`${service.icon} text-orange-600 text-2xl`} />
                </div>
                <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-slate-100 border border-slate-200 text-slate-600 ml-2 text-right flex-shrink-0">
                  {service.stat}
                </span>
              </div>
              <h3 className="font-display font-black text-slate-900 text-lg mb-3">{service.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed mb-4">{service.description}</p>
              <div className="flex flex-wrap gap-1.5">
                {service.features.map((f) => (
                  <span
                    key={f}
                    className="px-2 py-1 rounded-md text-xs bg-slate-50 border border-slate-200 text-slate-600 font-medium"
                  >
                    {f}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Mid CTA */}
        <div className="rounded-2xl border border-slate-200 bg-white p-8 flex flex-col md:flex-row items-center justify-between gap-5">
          <div>
            <p className="text-slate-900 font-display font-black text-xl mb-1">
              Get a Free Security System Installation Quote
            </p>
            <p className="text-slate-500 text-sm">
              Our specialists visit your property, design your system, and provide a transparent quote — no cost, no obligation.
            </p>
          </div>
          <Link
            to="#contact"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-slate-900 text-white font-black text-sm hover:bg-slate-800 transition-all duration-200 whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            Schedule Free Installation Quote
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
